import React from 'react';
import { Swords } from 'lucide-react';
import { Button } from '../ui/button';
import { MasterclassMentor, RPGFigure } from './MasterclassMentor';
import { clinicalCast } from './rpgCast';

export const MasterclassRPGIntro = ({ state, busy, onBegin }) => {
  const cast = clinicalCast(state);
  return (
  <section data-testid="masterclass-rpg-intro" className="mc-enter">
    <p className="mc-kicker mb-6" data-testid="rpg-briefing-label">INTERCONSULTA PRIORITARIA / GUARDIA ENARM</p>
    <div className="mc-briefing">
      <div className="mc-cast-stage" data-testid="rpg-case-figures">
        <MasterclassMentor figureId={cast.mentor} />
        <RPGFigure id={cast.patient} testId="rpg-patient-figure" className="mc-patient-figure" />
        <RPGFigure id={cast.equipment} testId="rpg-hospital-figure" className="mc-hospital-figure" />
      </div>
      <div className="mc-dialogue" data-testid="rpg-mentor-dialogue">
        <p className="mc-kicker mb-4">ESPECIALISTA MENTOR / {state.mentor}</p>
        <p className="text-base leading-relaxed">¡Hola, colega! Te doy la bienvenida a la guardia de <strong>{state.specialty}</strong>. Hoy revisaremos <strong>{state.title}</strong>. Nos esperan <strong>{state.total_questions} decisiones clínicas</strong>. Vamos a resolverlas juntos.</p>
      </div>
    </div>
    <div className="mc-quest-card mt-8" data-testid="rpg-quest-card">
      <div className="mc-quest-heading"><span>MISIÓN</span><span>{String(state.total_questions).padStart(2, '0')} DECISIONES</span></div>
      <h2 className="mb-6 text-base font-bold md:text-lg" data-testid="rpg-mission-name">{state.title}</h2>
      <div className="mb-6"><p className="mb-2 text-xs font-bold" data-testid="rpg-stability-label">ESTABILIDAD CLÍNICA</p><div className="mc-stability" role="img" aria-label="Estabilidad inicial del encuentro: cuatro de ocho bloques" data-testid="rpg-stability-blocks">{Array.from({ length: 8 }, (_, i) => <span key={i} className={i < 4 ? 'filled' : ''} />)}</div></div>
      <p className="mc-kicker mb-3">CONTEXTO CLÍNICO INICIAL</p>
      <p data-testid="rpg-case-summary" className="whitespace-pre-line border-l-4 border-black pl-4 text-sm leading-relaxed">{state.subtitulo_caso}</p>
      <p data-testid="rpg-mission-objective" className="mt-6 border-t border-dashed border-black pt-5 text-sm">Superar el reto socrático y dominar los criterios diagnósticos y terapéuticos ENARM.</p>
    </div>
    <Button data-testid="rpg-start-rotation" onClick={onBegin} disabled={busy} className="mc-command mt-8 w-full sm:w-auto"><Swords size={18} />{busy ? 'INICIANDO…' : '[ INICIAR ROTACIÓN CLÍNICA ]'}</Button>
  </section>
  );
};